require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./excepturi-tempora-assumenda-vitae-iure-alias.json") })
        }
      }, "path---excepturi-tempora-assumenda-vitae-iure-alias");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---excepturi-tempora-assumenda-vitae-iure-alias!./.cache/json/excepturi-tempora-assumenda-vitae-iure-alias.json
// module id = 395
// module chunks = 231608221292675